import { Quote, Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Marie L.",
    place: "Glebe · Residential",
    body:
      "Capital Shield never missed a single storm last winter. Driveway was always cleared before I left for work. Worth every dollar.",
  },
  {
    name: "Steven R.",
    place: "Barrhaven · Sealcoat",
    body:
      "Asphalt looks brand new. Crew showed up on time, prepped the cracks, and the finish is razor-sharp. Booking them again next summer.",
  },
  {
    name: "Priya K.",
    place: "Centretown · Seasonal",
    body:
      "Honest pricing, no surprises. They salted ahead of the freezing rain without me even calling. That's the kind of service I want.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <div className="hairline mb-6">Word in the Capital</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-2xl">
            Quiet mornings,
            <span className="text-[#C9A24B]"> happy neighbours.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0B1B3D] border border-white/10 p-8 hover:border-[#C9A24B]/40 hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="text-[#C9A24B]" size={28} />
              <div className="flex items-center gap-1 mt-4 mb-5">
                {[...Array(5)].map((_, idx) => (
                  <Star key={idx} size={14} className="fill-[#C9A24B] text-[#C9A24B]" />
                ))}
              </div>
              <p className="text-white/80 text-sm leading-relaxed mb-6">"{r.body}"</p>
              <div className="pt-5 border-t border-white/10">
                <div className="font-semibold text-white text-sm">{r.name}</div>
                <div className="text-xs text-[#9BD0E8] tracking-widest uppercase mt-1">
                  {r.place}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
